const FORMS_URL = 'https://editor.wix.com/_api/wix-form-builder-web'
const PLATFORMIZED_FORMS_URL = `${FORMS_URL}/v1`
const PREMIUM_RESTRICTIONS_ENDPOINT = `premium/restrictions`
export const PREMIUM_RESTRICTIONS_URL = `${PLATFORMIZED_FORMS_URL}/${PREMIUM_RESTRICTIONS_ENDPOINT}`
export const PAYMENT_RESTRICTION = 'PAYMENT_FORM'